export class ROUTE_CONSTANTS {
  static readonly root = '';

  static readonly maatAuditPlan = {
    list: 'maat-audit-plan-list'
  } as const;

  static readonly maatJob = {
    listPrefix: 'maat-job-list',
    list: 'maat-job-list/:maatAuditPlanId'
  } as const;

  static readonly maatJobItem = {
    listPrefix: 'maat-job-item-list',
    list: 'maat-job-item-list/:maatAuditPlanId/:maatJobId'
  } as const;

  static readonly maatNcq = {
    listPrefix: 'maat-ncq-list',
    list: 'maat-ncq-list/:maatAuditPlanId/:maatJobId/:maatJobItemId',
    prefix: 'maat-ncq-detail',
    new: 'maat-ncq-detail/:maatAuditPlanId/:maatJobId/:maatJobItemId',
    edit: 'maat-ncq-detail/:maatAuditPlanId/:maatJobId/:maatJobItemId/:maatNcqId'
  } as const;

  static readonly maatUser = {
    list: 'maat-user-list',
    prefix: 'maat-user-detail',
    edit: 'maat-user-detail/:id'
  } as const;

  static readonly maatSorDescription = {
    list: 'maat-sor-description-list',
    prefix: 'maat-sor-description-detail',
    edit: 'maat-sor-description-detail/:id'
  } as const;

  static readonly organisation = {
    list: 'organisation-list',
    prefix: 'organisation-detail',
    edit: 'organisation-detail/:id'
  } as const;

  static readonly team = {
    list: 'team-list',
    prefix: 'team-detail',
    edit: 'team-detail/:id'
  } as const;

  static readonly user = {
    list: 'user-list',
    prefix: 'user-detail',
    edit: 'user-detail/:id'
  } as const;

  static readonly inspection = {
    list: 'inspection-list',
    prefix: 'inspection-detail',
    listForBatch: 'inspection-list/batchId/:id',
    edit: 'inspection-detail/:templateId/:versionNo/:id',
    calendar: 'inspection-calendar'
  } as const;
  
  static readonly notification = {
    list: 'notification-list'
  } as const;

  static readonly report = {
    list: 'report-list'
  } as const;

  static readonly audit = {
    list: 'audit-list'
  } as const;

  static readonly batch = {
    list: 'batch-list'
  } as const;

  static readonly syncEntity = {
    list: 'sync-entity-list'
  } as const;
}
